import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Socket from '../components/Socket/Socket';
import {
  initiateWebsocketConnection,
  initializeSocket,
  socketConnected,
  socketDisconnected,
  showMultiSessionPrompt,
  startMonitorSession,
} from '../actions/socket';
import { enableFullScreen } from '../actions/proctor';
import {
  trackSocketConnectionError,
  trackSocketDisconnected,
  trackSocketError,
  trackCaptureScreen,
} from '../actions/eventTracking';
import { runCustomInputResult, runTestCasesResult } from '../actions/coding';

const mapStateToProps = state => {
  return {
    test: state.test,
    testSolutionSet: state.testSolutionSet,
    auth: state.auth,
    socketActive: state.socket.socketActive,
    fingerPrint: state.socket.fingerPrint,
    canWebsocketConnectionInitiated:
      state.socket.canWebsocketConnectionInitiated,
    trackVisibilityFocus: state.socket.trackVisibilityFocus,
    trackVisibilityBlur: state.socket.trackVisibilityBlur,
    captureScreenEvent: state.socket.captureScreenEvent,
    routeChange: state.socket.routeChange,
    showMultiSession: state.socket.showMultiSession,
    fullScreenEnabled: state.proctor.fullScreenEnabled,
    initSessionMonitorData: state.socket.initSessionMonitorData,
    assessment: state.assessment,
    toast: state.appStatus.toast,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      initiateWebsocketConnection,
      initializeSocket,
      socketConnected,
      socketDisconnected,
      trackSocketConnectionError,
      trackSocketDisconnected,
      trackSocketError,
      showMultiSessionPrompt,
      enableFullScreen,
      startMonitorSession,
      trackCaptureScreen,
      runCustomInputResult,
      runTestCasesResult,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Socket);
